<div>
  <nz-page-header class="bg-slate-100" [nzGhost]="false">
    <nz-page-header-title class=" text-primary flex items-center gap-2"
    >{{ 'users.title' | transloco }}
      <nz-icon  nz-tooltip
                nzTooltipPlacement = 'right'
                [nzTooltipArrowPointAtCenter]="true"
                [nzTooltipTitle]="'nav.featureTooltips.users' | transloco"
                [nzTooltipOverlayStyle]="{
                      'max-width': '400px',
                      'min-width': '300px',
                      'white-space': 'normal',
                      'line-height': '1.5'
                }"
                nz-icon nzType="info-circle" nzTheme="outline">
      </nz-icon>
    </nz-page-header-title>
    <nz-page-header-extra>
      <nz-space class="flex flex-col-reverse md:flex-row">
        <div class="pe-3 mt-2 md:mt-0">
          <nz-input-group nzSearch [nzAddOnAfter]="suffixButton" [nzSuffix]="inputClearTpl">
            <input
              type="text"
              nz-input
              [placeholder]="'users.searchPlaceholder' | transloco"
              (keydown.enter)="this.loadAllUsers()"
              [(ngModel)]="searchName"/>
          </nz-input-group>
          <ng-template #inputClearTpl>
            <span
              *ngIf="searchName"
              nz-icon
              class="ant-input-clear-icon"
              nzTheme="fill"
              nzType="close-circle"
              (click)="reset()"
            ></span>
          </ng-template>
          <ng-template #suffixButton>
            <button
              nz-button
              nzType="primary"
              nzSearch
              (click)="loadAllUsers()">
              {{ 'users.searchBtn' | transloco }}
            </button>
          </ng-template>
        </div>
        <div class="flex flex-row gap-3">
          <button
            *appHasAnyPrivilege="'ROLE.VIEW'"
            nz-button
            nzType="default"
            routerLink="/admin/roles"class="flex items-center justify-center gap-2">
            <lucide-icon name="user" class="icon-size"></lucide-icon>
            {{ 'users.manageRolesBtn' | transloco }}
          </button>
          <button
            *appHasAnyPrivilege="'USER.ADD'"
            nz-button
            nzType="primary"
            routerLink="/admin/users/add" class="flex items-center justify-center gap-2">
            <lucide-icon name="user-plus" class="icon-size"></lucide-icon>
            {{ 'users.addUserBtn' | transloco }}
          </button>
        </div>
      </nz-space>
    </nz-page-header-extra>
  </nz-page-header>
</div>
<div class="my-4">
  <nz-table
    #userTable
    [nzShowSizeChanger]="pageSize.length > 5"
    [nzPageSizeOptions]="pageSize.pageSizeOptions"
    [nzBordered]="true"
    [nzFrontPagination]="false"
    [nzTotal]="pageSize.length"
    [nzPageSize]="pageSize.pageSize"
    [nzPageIndex]="pageSize.pageIndex"
    (nzQueryParams)="onTableParamsChange($event)"
    [nzData]="allUsers"
    [nzScroll]="{ x: '1400px' }">
    <thead>
    <tr>
      <th>{{ 'users.table.fullName' | transloco }}</th>
      <th>{{ 'users.table.email' | transloco }}</th>
      <th>{{ 'users.table.role' | transloco }}</th>
      <th
        nzColumnKey="status"
        [nzFilters]="statusFilters"
        [nzFilterMultiple]="false"
        [nzShowFilter]="true"
        [nzFilterFn]="filterStatusFn">
        {{ 'users.table.status' | transloco }}
      </th>
      <th>{{ 'users.table.verified' | transloco }}</th>
      <th [nzSortFn]="sortColumn.compare">{{ 'users.table.createdDate' | transloco }}</th>
      <th *appHasAnyPrivilege="'USER.EDIT'">{{ 'users.table.action' | transloco }}</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let user of userTable.data">
      <td class="capitalize flex justify-start items-center">
        <img class="rounded-full w-12 h-12 object-cover mr-5" [src]=" user?.profilePic || this.profilePlaceholderPath" alt="profile">
        {{ user.firstname + ' ' + user.lastname }}
      </td>
      <td>{{ user.email }}</td>
      <td>
        <nz-tag [nzColor]="'cyan'">{{ user.role?.name }}</nz-tag>
      </td>
      <td>
        <nz-tag *ngIf="user.active" [nzColor]="'green'">{{ 'users.status.active' | transloco }}</nz-tag>
        <nz-tag *ngIf="!user.active" [nzColor]="'red'">{{ 'users.status.inactive' | transloco }}</nz-tag>
      </td>
      <td>
        <nz-tag *ngIf="user.isVerified" [nzColor]="'green'">{{ 'users.status.yes' | transloco }}</nz-tag>
        <nz-tag *ngIf="!user.isVerified" [nzColor]="'red'">{{ 'users.status.no' | transloco }}</nz-tag>
      </td>
      <td>{{ user.createdAt | date }}</td>
      <td *appHasAnyPrivilege="'USER.EDIT'">
        <button
          *appHasAnyPrivilege="'USER.EDIT'"
          nz-button
          nzType="default"
          nzSize="small"
          [routerLink]="'/admin/users/edit/' + user._id" class="flex items-center justify-center gap-2">
          <lucide-icon name="pencil"  class="icon-size"></lucide-icon>
          {{ 'users.editBtn' | transloco }}
        </button>
      </td>
    </tr>
    </tbody>
  </nz-table>
</div>
